/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminRaiser,
  AdminRaiserDetail,
  AdminUpdate,
  ContactMessage,
  ContactMessageInput,
  ContactMessageStatusUpdate,
  ContactReply,
  ContactReplyInput,
  ErrorEnvelope,
  HealthStatus,
  RaiserApplication,
  RaiserApplicationInput,
  RaiserApplicationReceipt,
  RaiserApplicationStatusUpdate,
  RaiserProfile,
  RaiserProfileInput,
  RaiserProfileOrNull,
  Update,
  UpdateInput,
  UploadUrlRequest,
  UploadUrlResponse,
  User
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * Returns the current authenticated user, provisioning a local record on first call.
 * @summary Get current user
 */
export const getMe = async ( options?: RequestInit): Promise<User> => {

  return customFetch<User>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get current user
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Get current raiser profile
 */
export const getMyProfile = async ( options?: RequestInit): Promise<RaiserProfileOrNull> => {

  return customFetch<RaiserProfileOrNull>(getGetMyProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyProfileQueryKey = () => {
    return [
    `/api/me/profile`
    ] as const;
    }


export const getGetMyProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProfile>>> = ({ signal }) => getMyProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProfile>>>
export type GetMyProfileQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get current raiser profile
 */

export function useGetMyProfile<TData = Awaited<ReturnType<typeof getMyProfile>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertMyProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Create or update current raiser profile
 */
export const upsertMyProfile = async (raiserProfileInput: RaiserProfileInput, options?: RequestInit): Promise<RaiserProfile> => {

  return customFetch<RaiserProfile>(getUpsertMyProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(raiserProfileInput)
  }
);}




export const getUpsertMyProfileMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMyProfile>>, TError,{data: BodyType<RaiserProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertMyProfile>>, TError,{data: BodyType<RaiserProfileInput>}, TContext> => {

const mutationKey = ['upsertMyProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertMyProfile>>, {data: BodyType<RaiserProfileInput>}> = (props) => {
          const {data} = props ?? {};

          return  upsertMyProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof upsertMyProfile>>>
    export type UpsertMyProfileMutationBody = BodyType<RaiserProfileInput>
    export type UpsertMyProfileMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Create or update current raiser profile
 */
export const useUpsertMyProfile = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertMyProfile>>, TError,{data: BodyType<RaiserProfileInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertMyProfile>>,
        TError,
        {data: BodyType<RaiserProfileInput>},
        TContext
      > => {
      return useMutation(getUpsertMyProfileMutationOptions(options));
    }

export const getGetMyUpdatesUrl = () => {




  return `/api/me/updates`
}

/**
 * @summary List current raiser's updates
 */
export const getMyUpdates = async ( options?: RequestInit): Promise<Update[]> => {

  return customFetch<Update[]>(getGetMyUpdatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyUpdatesQueryKey = () => {
    return [
    `/api/me/updates`
    ] as const;
    }


export const getGetMyUpdatesQueryOptions = <TData = Awaited<ReturnType<typeof getMyUpdates>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyUpdates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyUpdatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyUpdates>>> = ({ signal }) => getMyUpdates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyUpdates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyUpdatesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyUpdates>>>
export type GetMyUpdatesQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List current raiser's updates
 */

export function useGetMyUpdates<TData = Awaited<ReturnType<typeof getMyUpdates>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyUpdates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyUpdatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateMyUpdateUrl = () => {




  return `/api/me/updates`
}

/**
 * @summary Submit a new update
 */
export const createMyUpdate = async (updateInput: UpdateInput, options?: RequestInit): Promise<Update> => {

  return customFetch<Update>(getCreateMyUpdateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateInput)
  }
);}




export const getCreateMyUpdateMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyUpdate>>, TError,{data: BodyType<UpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMyUpdate>>, TError,{data: BodyType<UpdateInput>}, TContext> => {

const mutationKey = ['createMyUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyUpdate>>, {data: BodyType<UpdateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMyUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof createMyUpdate>>>
    export type CreateMyUpdateMutationBody = BodyType<UpdateInput>
    export type CreateMyUpdateMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Submit a new update
 */
export const useCreateMyUpdate = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyUpdate>>, TError,{data: BodyType<UpdateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMyUpdate>>,
        TError,
        {data: BodyType<UpdateInput>},
        TContext
      > => {
      return useMutation(getCreateMyUpdateMutationOptions(options));
    }

export const getGetMyUpdateUrl = (id: number,) => {




  return `/api/me/updates/${id}`
}

/**
 * @summary Get one of the current raiser's updates
 */
export const getMyUpdate = async (id: number, options?: RequestInit): Promise<Update> => {

  return customFetch<Update>(getGetMyUpdateUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyUpdateQueryKey = (id: number,) => {
    return [
    `/api/me/updates/${id}`
    ] as const;
    }


export const getGetMyUpdateQueryOptions = <TData = Awaited<ReturnType<typeof getMyUpdate>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyUpdate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyUpdateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyUpdate>>> = ({ signal }) => getMyUpdate(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyUpdate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof getMyUpdate>>>
export type GetMyUpdateQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get one of the current raiser's updates
 */

export function useGetMyUpdate<TData = Awaited<ReturnType<typeof getMyUpdate>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyUpdate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyUpdateQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminRaisersUrl = () => {




  return `/api/admin/raisers`
}

/**
 * @summary List all raisers (staff only)
 */
export const getAdminRaisers = async ( options?: RequestInit): Promise<AdminRaiser[]> => {

  return customFetch<AdminRaiser[]>(getGetAdminRaisersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRaisersQueryKey = () => {
    return [
    `/api/admin/raisers`
    ] as const;
    }


export const getGetAdminRaisersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRaisers>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRaisers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRaisersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRaisers>>> = ({ signal }) => getAdminRaisers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRaisers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminRaisersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRaisers>>>
export type GetAdminRaisersQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List all raisers (staff only)
 */

export function useGetAdminRaisers<TData = Awaited<ReturnType<typeof getAdminRaisers>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRaisers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminRaisersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminRaiserUrl = (id: number,) => {




  return `/api/admin/raisers/${id}`
}

/**
 * @summary Get one raiser with their updates (staff only)
 */
export const getAdminRaiser = async (id: number, options?: RequestInit): Promise<AdminRaiserDetail> => {

  return customFetch<AdminRaiserDetail>(getGetAdminRaiserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRaiserQueryKey = (id: number,) => {
    return [
    `/api/admin/raisers/${id}`
    ] as const;
    }


export const getGetAdminRaiserQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRaiser>>, TError = ErrorType<ErrorEnvelope>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRaiser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRaiserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRaiser>>> = ({ signal }) => getAdminRaiser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRaiser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminRaiserQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRaiser>>>
export type GetAdminRaiserQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Get one raiser with their updates (staff only)
 */

export function useGetAdminRaiser<TData = Awaited<ReturnType<typeof getAdminRaiser>>, TError = ErrorType<ErrorEnvelope>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminRaiser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminRaiserQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminUpdatesUrl = () => {




  return `/api/admin/updates`
}

/**
 * @summary List all updates across raisers (staff only)
 */
export const getAdminUpdates = async ( options?: RequestInit): Promise<AdminUpdate[]> => {

  return customFetch<AdminUpdate[]>(getGetAdminUpdatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminUpdatesQueryKey = () => {
    return [
    `/api/admin/updates`
    ] as const;
    }


export const getGetAdminUpdatesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUpdates>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUpdates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUpdatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUpdates>>> = ({ signal }) => getAdminUpdates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUpdates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUpdatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUpdates>>>
export type GetAdminUpdatesQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List all updates across raisers (staff only)
 */

export function useGetAdminUpdates<TData = Awaited<ReturnType<typeof getAdminUpdates>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUpdates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUpdatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminContactMessagesUrl = () => {




  return `/api/admin/contact-messages`
}

/**
 * @summary List all contact form submissions (staff only)
 */
export const getAdminContactMessages = async ( options?: RequestInit): Promise<ContactMessage[]> => {

  return customFetch<ContactMessage[]>(getGetAdminContactMessagesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminContactMessagesQueryKey = () => {
    return [
    `/api/admin/contact-messages`
    ] as const;
    }


export const getGetAdminContactMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminContactMessages>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminContactMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminContactMessagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminContactMessages>>> = ({ signal }) => getAdminContactMessages({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminContactMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminContactMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminContactMessages>>>
export type GetAdminContactMessagesQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List all contact form submissions (staff only)
 */

export function useGetAdminContactMessages<TData = Awaited<ReturnType<typeof getAdminContactMessages>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminContactMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminContactMessagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateContactMessageStatusUrl = (id: number,) => {




  return `/api/admin/contact-messages/${id}`
}

/**
 * @summary Update the status of a contact message (staff only)
 */
export const updateContactMessageStatus = async (id: number,
    contactMessageStatusUpdate: ContactMessageStatusUpdate, options?: RequestInit): Promise<ContactMessage> => {

  return customFetch<ContactMessage>(getUpdateContactMessageStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contactMessageStatusUpdate)
  }
);}




export const getUpdateContactMessageStatusMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactMessageStatus>>, TError,{id: number;data: BodyType<ContactMessageStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContactMessageStatus>>, TError,{id: number;data: BodyType<ContactMessageStatusUpdate>}, TContext> => {

const mutationKey = ['updateContactMessageStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactMessageStatus>>, {id: number;data: BodyType<ContactMessageStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateContactMessageStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactMessageStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactMessageStatus>>>
    export type UpdateContactMessageStatusMutationBody = BodyType<ContactMessageStatusUpdate>
    export type UpdateContactMessageStatusMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Update the status of a contact message (staff only)
 */
export const useUpdateContactMessageStatus = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactMessageStatus>>, TError,{id: number;data: BodyType<ContactMessageStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateContactMessageStatus>>,
        TError,
        {id: number;data: BodyType<ContactMessageStatusUpdate>},
        TContext
      > => {
      return useMutation(getUpdateContactMessageStatusMutationOptions(options));
    }

export const getSendContactMessageReplyUrl = (id: number,) => {




  return `/api/admin/contact-messages/${id}/replies`
}

/**
 * Sends a transactional email reply to the original sender, stores the reply against the message, and marks the message as resolved.
 * @summary Send a reply to a contact message (staff only)
 */
export const sendContactMessageReply = async (id: number,
    contactReplyInput: ContactReplyInput, options?: RequestInit): Promise<ContactReply> => {

  return customFetch<ContactReply>(getSendContactMessageReplyUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contactReplyInput)
  }
);}




export const getSendContactMessageReplyMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendContactMessageReply>>, TError,{id: number;data: BodyType<ContactReplyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendContactMessageReply>>, TError,{id: number;data: BodyType<ContactReplyInput>}, TContext> => {

const mutationKey = ['sendContactMessageReply'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendContactMessageReply>>, {id: number;data: BodyType<ContactReplyInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  sendContactMessageReply(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendContactMessageReplyMutationResult = NonNullable<Awaited<ReturnType<typeof sendContactMessageReply>>>
    export type SendContactMessageReplyMutationBody = BodyType<ContactReplyInput>
    export type SendContactMessageReplyMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Send a reply to a contact message (staff only)
 */
export const useSendContactMessageReply = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendContactMessageReply>>, TError,{id: number;data: BodyType<ContactReplyInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendContactMessageReply>>,
        TError,
        {id: number;data: BodyType<ContactReplyInput>},
        TContext
      > => {
      return useMutation(getSendContactMessageReplyMutationOptions(options));
    }

export const getSubmitContactMessageUrl = () => {




  return `/api/contact`
}

/**
 * Public endpoint — anyone can send a message to the organization.
 * @summary Submit a contact form message
 */
export const submitContactMessage = async (contactMessageInput: ContactMessageInput, options?: RequestInit): Promise<ContactMessage> => {

  return customFetch<ContactMessage>(getSubmitContactMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contactMessageInput)
  }
);}




export const getSubmitContactMessageMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContactMessage>>, TError,{data: BodyType<ContactMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitContactMessage>>, TError,{data: BodyType<ContactMessageInput>}, TContext> => {

const mutationKey = ['submitContactMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitContactMessage>>, {data: BodyType<ContactMessageInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitContactMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitContactMessageMutationResult = NonNullable<Awaited<ReturnType<typeof submitContactMessage>>>
    export type SubmitContactMessageMutationBody = BodyType<ContactMessageInput>
    export type SubmitContactMessageMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Submit a contact form message
 */
export const useSubmitContactMessage = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContactMessage>>, TError,{data: BodyType<ContactMessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitContactMessage>>,
        TError,
        {data: BodyType<ContactMessageInput>},
        TContext
      > => {
      return useMutation(getSubmitContactMessageMutationOptions(options));
    }

export const getSubmitRaiserApplicationUrl = () => {




  return `/api/applications`
}

/**
 * Public endpoint — anyone can apply to become a volunteer puppy raiser.
 * @summary Submit a puppy raiser application
 */
export const submitRaiserApplication = async (raiserApplicationInput: RaiserApplicationInput, options?: RequestInit): Promise<RaiserApplicationReceipt> => {

  return customFetch<RaiserApplicationReceipt>(getSubmitRaiserApplicationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(raiserApplicationInput)
  }
);}




export const getSubmitRaiserApplicationMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRaiserApplication>>, TError,{data: BodyType<RaiserApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitRaiserApplication>>, TError,{data: BodyType<RaiserApplicationInput>}, TContext> => {

const mutationKey = ['submitRaiserApplication'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitRaiserApplication>>, {data: BodyType<RaiserApplicationInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitRaiserApplication(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitRaiserApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof submitRaiserApplication>>>
    export type SubmitRaiserApplicationMutationBody = BodyType<RaiserApplicationInput>
    export type SubmitRaiserApplicationMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Submit a puppy raiser application
 */
export const useSubmitRaiserApplication = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitRaiserApplication>>, TError,{data: BodyType<RaiserApplicationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitRaiserApplication>>,
        TError,
        {data: BodyType<RaiserApplicationInput>},
        TContext
      > => {
      return useMutation(getSubmitRaiserApplicationMutationOptions(options));
    }

export const getGetAdminApplicationsUrl = () => {




  return `/api/admin/applications`
}

/**
 * @summary List all puppy raiser applications (staff only)
 */
export const getAdminApplications = async ( options?: RequestInit): Promise<RaiserApplication[]> => {

  return customFetch<RaiserApplication[]>(getGetAdminApplicationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminApplicationsQueryKey = () => {
    return [
    `/api/admin/applications`
    ] as const;
    }


export const getGetAdminApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminApplications>>> = ({ signal }) => getAdminApplications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminApplications>>>
export type GetAdminApplicationsQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary List all puppy raiser applications (staff only)
 */

export function useGetAdminApplications<TData = Awaited<ReturnType<typeof getAdminApplications>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminApplications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminApplicationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateApplicationStatusUrl = (id: number,) => {




  return `/api/admin/applications/${id}`
}

/**
 * @summary Update the status of a puppy raiser application (staff only)
 */
export const updateApplicationStatus = async (id: number,
    raiserApplicationStatusUpdate: RaiserApplicationStatusUpdate, options?: RequestInit): Promise<RaiserApplication> => {

  return customFetch<RaiserApplication>(getUpdateApplicationStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(raiserApplicationStatusUpdate)
  }
);}




export const getUpdateApplicationStatusMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplicationStatus>>, TError,{id: number;data: BodyType<RaiserApplicationStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApplicationStatus>>, TError,{id: number;data: BodyType<RaiserApplicationStatusUpdate>}, TContext> => {

const mutationKey = ['updateApplicationStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApplicationStatus>>, {id: number;data: BodyType<RaiserApplicationStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateApplicationStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateApplicationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateApplicationStatus>>>
    export type UpdateApplicationStatusMutationBody = BodyType<RaiserApplicationStatusUpdate>
    export type UpdateApplicationStatusMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Update the status of a puppy raiser application (staff only)
 */
export const useUpdateApplicationStatus = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApplicationStatus>>, TError,{id: number;data: BodyType<RaiserApplicationStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateApplicationStatus>>,
        TError,
        {id: number;data: BodyType<RaiserApplicationStatusUpdate>},
        TContext
      > => {
      return useMutation(getUpdateApplicationStatusMutationOptions(options));
    }

export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * Returns a presigned GCS URL for direct upload. The client sends JSON
 * metadata here, then uploads the file directly to the returned URL.
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetPublicObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * Unconditionally public — no authentication or ACL checks.
 * Searches PUBLIC_OBJECT_SEARCH_PATHS for the given file path.
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getPublicObject = async (filePath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({ signal }) => getPublicObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: filePath !== null && filePath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicObject>>>
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * Serves object entities uploaded via presigned URLs. These can optionally
 * be protected with authentication or ACL checks based on the use case.
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







